// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import LangRU from './lang/ru'
import LangKZ from './lang/kz'
import AuthFunction from './functions/Auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as jqueryjs from './assets/js/jquery-1.12.1.min.js'
import * as bootstrapjs from './assets/js/bootstrap.min.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import { directive as onClickOutside } from 'vue-on-click-outside'
import moment from 'moment'
import Meta from 'vue-meta'
import { BASE_DOMAIN } from './_config'

Vue.prototype.$baseDomain = BASE_DOMAIN
Vue.use(Meta)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.prototype.moment = moment
Vue.use(require('vue-moment'))
Vue.directive('on-click-outside', onClickOutside)
Vue.use(jqueryjs, bootstrapjs)
Vue.prototype.$axios = axios
Vue.prototype.$auth = new AuthFunction()
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
// Vue.use(VueInstagram)

const AppLang = () => {
  return AuthFunction().getLanguage()
}

// axios.defaults.baseURL = 'https://seiflombard.kz/api/v2/'
axios.defaults.baseURL = `${BASE_DOMAIN}/api/v2/`
if (AuthFunction().getToken()) {
  axios.defaults.headers.common['Authorization'] = AuthFunction().getToken()
}

const messages = {
  ru: LangRU,
  kz: LangKZ
}

const i18n = new VueI18n({
  locale: AppLang(),
  messages
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDMQvVdD6efZcd63plLrcZWb8iaM9QwAbI'
  }
})

const filter = function (text, length, clamp) {
  clamp = clamp || '...'
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter('truncate', filter)
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YY')
  }
})
/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js